// extracted by mini-css-extract-plugin
module.exports = {"legendItem":"styles_legendItem__OZ37j"};